import { useAfterRegister } from '@goparrot-dashboard-api/auth';
import { useCreateUser } from '@goparrot-dashboard-api/users';
import { useNotifications, PageTitle, PositiveFeedback } from '@goparrot-dashboard/shared-ui';
import { useI18n } from '@goparrot-dashboard/i18n';
import * as React from 'react';
import { SignInSubtitle } from '../components/SignInSubtitle';
import { RegisterForm } from '../forms/RegisterForm';

/**
 * @description Page for self-register
 */
export const RegisterPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { getIntlString } = useI18n();
  const { notifyError } = useNotifications();

  const afterRegister = useAfterRegister();
  const createUser = useCreateUser({
    onSuccess: (_, { email }) => {
      afterRegister(email);
    },
    onError: (error) => {
      if (error?.response?.status === 409) {
        notifyError({
          text: getIntlString('error.emailInUse'),
        });
      } else {
        notifyError({
          text: getIntlString('notification.genericErrorResponse', { isRootPath: true }),
        });
      }
    },
  });

  return (
    <article className="tw-text-base">
      <header>
        <PageTitle hasMargin={false} fontWeight="medium" seoTitle={getIntlString('title.signUp')}>
          {getIntlString('title.signUp')}
        </PageTitle>
        <SignInSubtitle />
      </header>

      <section className="tw-mt-4">
        {!createUser?.data ? (
          <RegisterForm onSubmit={(data) => createUser.mutate({ email: data.email, password: data.password })} isFormLoading={createUser.isLoading} />
        ) : (
          <PositiveFeedback className="tw--mx-8" title={getIntlString('feedback.register.title')} subtitle={getIntlString('feedback.register.subtitle')} />
        )}
      </section>
    </article>
  );
};
